import axios from "@/plugins/axios";

export default {
  getHistory(query) {
    return axios.get("/history", { params: query });
  },
};
